<template>
  <swiper ref="mySwiper" :options="swiperOption">
    <swiper-slide v-for="(values, index) in showImgListTransform" :key="index">
      <a-row :gutter="32" class="imgWrap">
        <a-col :span="6" v-for="(value, index) in values" :key="index">
          <img :src="value" width="100%" :data-key="index" />
        </a-col>
      </a-row>
    </swiper-slide>
    <div class="swiper-pagination" slot="pagination"></div>
  </swiper>
</template>

<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import { mapGetters } from 'vuex'
export default {
  name: 'SlideTop',
  data() {
    const _this = this
    return {
      swiperOption: {
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        // navigation: {
        //   nextEl: '.swiper-button-next',
        //   prevEl: '.swiper-button-prev'
        // },
        initialSlide: 0,
        on: {
          click: function(e) {
            const { realIndex } = this
            const changeIndexValue = parseInt(realIndex) * 4 + parseInt(e.target.dataset.key)
            console.log(changeIndexValue)
            _this.$emit('change', changeIndexValue)
          }
        }
      }
    }
  },
  components: {
    Swiper,
    SwiperSlide
  },
  // updated() {
  //   this.changeIndex(0)
  // },
  methods: {
    changeIndex(index) {
      const swiper = this.$refs.mySwiper.$swiper
      swiper.slideTo(index + 1, 300, false)
    }
  },
  mounted() {
    this.changeIndex(-1)
  },
  computed: {
    ...mapGetters(['showImgListTransform', 'show_images_design'])
  }
}
</script>

<style scoped lang="less">
.swiper-pagination {
  bottom: 0;
}
.imgWrap {
  height: 124px;
  margin-left: 0 !important;
  margin-right: 0 !important;
  padding-top: 10px;
  img {
    box-shadow: 0px 3px 7px 0px rgba(0, 0, 0, 0.35);
    border-radius: 5px;
    &:hover {
      cursor: pointer;
    }
  }
}
.unique {
  position: absolute;
  left: -2px;
  top: 0;
}
</style>
